import React from "react";
import "./css/sections.css";
import IMG from "../assets/images/cleaning13.jpg";
import seaVideo2 from "../assets/videos/Seatech.mp4";
// import IMG from "../assets/images/indiancleaningguy.png";

function aboutUs() {
  return (
    <div id="about" className="about-us-container">
      <div className="about-us-inner-container">
        <div className="about-us-header">
          <h1>ABOUT US</h1>
          <div className="divider"></div>
        </div>
        <div className="about-us-content-container">
          <video src={seaVideo2} autoPlay loop muted className="about-us-image" />
          <div className="about-us-content">
            <h2>Over 5 Years Experience In Industry</h2>
            <p className="description">
              Seatech Infra is actively engaged in executing sanitation and
              infrastructure support projects across major cities, including
              Ahmedabad, Delhi, and Mumbai. Our efforts are focused on
              strengthening civic resilience and enhancing public health in
              rapidly growing urban environments.
              <br />
              <br />
              Driven by an unwavering commitment to quality and safety, Seatech
              Infra is steadily expanding its presence to meet the evolving
              needs of urban populations across India. We aim to deliver
              scalable and sustainable solutions for efficient infrastructure
              management.
              <br />
              <br />
              With a comprehensive suite of services, Seatech Infra specializes
              in urban sanitation and infrastructure support, empowering cities
              with reliable, future-ready systems that improve everyday life for
              citizens.
            </p>

            {/* <ul className="features-list">
              <li>Renovation of office furniture</li>
              <li>Make Quality Products</li>
              <li>Hardwood Flooring</li>
              <li>Interior Furniture Manufacturing</li>
              <li>Excellent Designing</li>
              <li>Repairing of wooden almerah</li>
            </ul> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default aboutUs;
